import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1442042037589312';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // If already loaded, just track PageView
      if (window.fbq) {
        window.fbq('track', 'PageView');
      } else {
        // Initialize fbq queue
        const fbq: any = function () {
          // eslint-disable-next-line prefer-rest-params
          fbq.callMethod ?
          // eslint-disable-next-line prefer-rest-params
          fbq.callMethod.apply(fbq, arguments) :
          // eslint-disable-next-line prefer-rest-params
          fbq.queue.push(arguments);
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = fbq;
        // Inject script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const first = document.getElementsByTagName('script')[0];
        if (first && first.parentNode) {
          first.parentNode.insertBefore(script, first);
        } else {
          document.head.appendChild(script);
        }
        window.fbq('init', PIXEL_ID);
        window.fbq('track', 'PageView');
      }
      // Track InitiateCheckout on purchase link clicks
      const handler = (e: MouseEvent) => {
        const target = e.target as HTMLElement | null;
        if (!target) return;
        const anchor = target.closest('a') as HTMLAnchorElement | null;
        if (!anchor) return;
        const href = anchor.getAttribute('href') || '';
        if (href.indexOf('digitalbibliotec.online/cart/') !== -1) {
          const value = href.indexOf('52276164100378') !== -1 ? 27990 : 19990;
          try {
            window.fbq && window.fbq('track', 'InitiateCheckout', {
              value: value,
              currency: 'ARS'
            });
          } catch (err) {
            // no-op
          }
        }
      };
      document.addEventListener('click', handler);
      return () => document.removeEventListener('click', handler);
    } catch (err) {
      // Never let the pixel break the page
      console.warn('Meta Pixel init failed', err);
    }
  }, []);
  return <noscript data-id="element-190">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={'https://www.facebook.com/tr?id=' + PIXEL_ID + '&ev=PageView&noscript=1'} data-id="element-191" />
    </noscript>;
}